import { useServices } from "../core/app-context";

export function Logo({ className }: { className?: string }) {
  const { config } = useServices();
  return <img src={config.theme.logo.src} alt={config.theme.logo.alt} className={className ?? "h-7 w-auto"} />;
}
